import { EsponenteDto } from "@api/client";
import { companyIdCompanySelector } from "common/_redux/company/selectors";
import {
	subjectAddSubject,
	subjectGetDetails,
	subjectSearchSubject,
	subjectSetIdLegaleRappresentante,
} from "common/_redux/subject/actions";
import { legaleRappresentanteSelector } from "common/_redux/subject/selectors";
import BftButton from "common/components/button";
import { TipoInserimento } from "constants/global";
import { AppRouterService } from "core/routes/app-router.service";
import { PathEnum } from "core/routes/path.enum";
import { useAppDispatch, useAppSelector } from "core/store/hooks";
import { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const title = "3. I tuoi dati";
const subtitle =
	"Raccontaci di te! Seleziona il tuo profilo fra quelli proposti o creane uno se non presente.";

const SceltaLegaleRappresentante: React.FC = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const idCompany = useAppSelector(companyIdCompanySelector);
	const legaleRapp = useAppSelector(legaleRappresentanteSelector);

	const [legaliRappresentantiList, setLegaliRappresentantiList] = useState<EsponenteDto[]>([]);

	const goBack = () => {
		navigate(-1);
	};

	const searchSubjects = () => {
		dispatch(subjectSearchSubject(false))
			.unwrap()
			.then((res) => {
				if (res?.esponenti && res.esponenti.length > 0) {
					setLegaliRappresentantiList(res?.esponenti);
				} else {
					addSubjectAndNavigate("0");
				}
			});
	};

	const addSubjectAndNavigate = (idEsponente: string | undefined) => {
		if (!idEsponente) {
			return;
		}

		dispatch(subjectSetIdLegaleRappresentante(idEsponente));

		dispatch(subjectAddSubject(idEsponente))
			.unwrap()
			.then((res) => {
				if (res) {
					dispatch(subjectGetDetails())
						.unwrap()
						.then((subjectsRes) => {
							if (subjectsRes) {
								// console.log(subjectsRes);
								navigate(AppRouterService.get(PathEnum.identificazioneLegaleRappresentante));
							}
						});
				}
			});
	};

	const navigateLR = () => {
		navigate(AppRouterService.get(PathEnum.anagraficaLR));
	};

	useEffect(() => {
		if (!legaleRapp) {
			if (idCompany && idCompany !== TipoInserimento.MANUALE) {
				searchSubjects();
			} else {
				console.log("sono entrato qui");
				addSubjectAndNavigate("0");
			}
		}
	}, []);

	return (
		<>
			<h2 className="mb-3 ms-3">{title}</h2>
			<span className="gray fw-bold">{subtitle}</span>

			{legaleRapp ? (
				<p className="text-danger fw-bold m-3">
					Hai già scelto il Legale Rappresentante, vai allo step successivo!
				</p>
			) : (
				<div>
					{legaliRappresentantiList?.map((soggetto) => (
						<div key={soggetto.idEsponente}>
							<Card
								className="shadow clickable"
								onClick={() => addSubjectAndNavigate(soggetto?.idEsponente)}
							>
								<Card.Body>
									<div className="d-flex align-items-center">
										<div>
											<div className={`square-icon-shadow icon-card-v2`}>
												<div className="square-icon-container">
													<i className={`fas fa-user square-icon`}></i>
												</div>
											</div>
										</div>
										<div>
											<h6 className="m-0 ms-3">
												{soggetto.nome} {soggetto.cognome}
											</h6>
											<span className="gray small">{"Legale Rappresentante"}</span>
										</div>
										<div className="text-center ms-auto">
											<i className="fa-solid fa-chevron-right"></i>
										</div>
									</div>
								</Card.Body>
							</Card>
						</div>
					))}
					<Card className="shadow">
						<Card.Body>
							<div className="d-flex align-items-center">
								<div className="col-11">
									<h6 className="m-0 ms-3">Non sei presente in questa lista?</h6>
									<span className="gray small">
										Seleziona questa opzione se il tuo nome non è presente nei nominativi
										dell'elenco.
									</span>
								</div>
								<div className="col-1 text-center">
									<BftButton
										className="btn-buffetti-secondary"
										onClick={() => addSubjectAndNavigate("0")}
										style={{
											minHeight: "2rem",
											width: "2rem",
											fontSize: "1rem",
											padding: "0",
											borderRadius: "0.375rem",
											marginRight: "1rem",
										}}
									>
										+
									</BftButton>
								</div>
							</div>
						</Card.Body>
					</Card>
				</div>
			)}

			<Row className="justify-content-between mx-3">
				<Col xs={2} lg={1} className="p-0">
					<BftButton className="btn-buffetti-secondary ms-0 px-3" onClick={goBack}>
						<i className="fas fa-arrow-left"></i>
					</BftButton>
				</Col>
				<Col xs={10} lg={11} className="p-0">
					{legaleRapp && (
						<div className="">
							<BftButton className="btn-buffetti" type="submit" onClick={navigateLR}>
								Avanti
							</BftButton>
						</div>
					)}
				</Col>
			</Row>
		</>
	);
};

export default SceltaLegaleRappresentante;
